'use strict';

bbw.filter.profileUrl = [function() {
    return function(userId, tpl, args) {
        if (!userId) {
            return undefined;
        }
        var prefix;
        if (bbw.userId == userId) {
            prefix = '/profile';
        } else {
            prefix = '/0' + userId;
        }
        if (!tpl) {
            return prefix;
        }
        var qs = angular.isObject(args) ? ngtk.tools.string.parseTemplate(tpl, args, '#') : tpl;
        return prefix + '?' + qs;
    }
}];
